import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
        Heading: () => <>Things to Do</>,
        SubHeading: () => (
            <>
                Here's some suggestions for sightseeing around Chiang Mai.
            </>
        ),
        link: "https://www.tourismthailand.org/Destinations/Provinces/Chiang-Mai/101",
    },
    [LANGUAGE.ZH]: {
        Heading: () => <>玩儿在清迈</>,
        SubHeading: () => (
            <>
                更多内容，敬请期待！
            </>
        ),
        link: "http://amazingthailand.org.cn/Content/Index/shows/catid/110/id/2.html",
    },
}
